import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { copyFor } from '../../copy/copy';

const TwitterIcon = props => (
    <svg
        width={props.isMobileResolution ? 52 : 36}
        height={props.isMobileResolution ? 52 : 36}
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'twitter')}</title>
        <path
            d="M23.903 13.74a3.122 3.122 0 0 0 1.31-1.74 5.784 5.784 0 0 1-1.894.763 2.904 2.904 0 0 0-2.177-.994c-1.647 0-2.981 1.409-2.981 3.146 0 .246.024.487.075.716-2.478-.131-4.675-1.382-6.147-3.287a3.27 3.27 0 0 0-.404 1.583c0 1.09.527 2.053 1.327 2.619a2.876 2.876 0 0 1-1.351-.394v.039c0 1.525 1.027 2.796 2.393 3.084-.25.074-.513.111-.787.111-.192 0-.38-.019-.56-.056.379 1.25 1.48 2.16 2.786 2.185a5.79 5.79 0 0 1-4.416 1.303 8.133 8.133 0 0 0 4.572 1.413c5.487 0 8.486-4.794 8.486-8.95 0-.138-.002-.274-.008-.408a6.235 6.235 0 0 0 1.488-1.629c-.535.25-1.11.42-1.712.495z"
            fillRule="nonzero"
            fill="#000"
        />
    </svg>
);

TwitterIcon.propTypes = {
    isMobileResolution: PropTypes.bool.isRequired
};

export default connect(
    state => ({
        isMobileResolution: state.widget.isMobileResolution
    }),
    {}
)(TwitterIcon);
